import { localizedInitiateSecurityKYC } from "../../intl/shared-resources/initiateSecurityKYC.js";
import { ChipVariant } from "../../components/chip/types.js";
import "../../components/icons/Icon.js";
import "react";
import { CustomIcon } from "../../components/icons/types.js";
import "../../components/icons/ExpandMoreIcon.js";
import { AccountVerificationStatus } from "../../contract/pam.js";
const getBulkAccountVerificationStatusChipsMapping = (chipType) => ({
  [AccountVerificationStatus.InitLoginKyc]: {
    label: localizedInitiateSecurityKYC[AccountVerificationStatus.InitLoginKyc],
    chipType,
    chipVariant: ChipVariant.Disabled,
    startIconClass: CustomIcon.UserOutline
  },
  [AccountVerificationStatus.InitWithdrawalKyc]: {
    label: localizedInitiateSecurityKYC[AccountVerificationStatus.InitWithdrawalKyc],
    chipType,
    chipVariant: ChipVariant.Disabled,
    startIconClass: CustomIcon.TransferOutline
  }
});
export {
  getBulkAccountVerificationStatusChipsMapping
};
//# sourceMappingURL=bulkAccountVerificationStatusConfig.js.map
